'use strict';

import ziggyRoute from "../../vendor/tightenco/ziggy/src/js/route.js";

export default function route(name, params, absolute) {
	try {
		return ziggyRoute(name, params, absolute, window.Ziggy);
	} catch (e) {
		console.error(e);
		
		if ('bugsnagClient' in window) {
			window.bugsnagClient.notify(e);
		}
		
		return 'https://www.nachi.org/';
	}
};
